<template>
  <div class="shop-footer">
    <div class="shop-footer__content">
      <div class="shop-footer__cart--empty" v-if="isCartEmpty">
        Your cart is empty.
        <span class="shop-footer__cart--empty-secondary"> Select a product to continue. </span>
      </div>
      <div class="shop-footer__cart-wrapper">
        <div class="shop-footer__cart-total-wrapper" v-if="!isCartEmpty">
          <Pill cart class="shop-footer__cart-pill">
            {{ `${cartItemsCount} Item${cartItemsCount > 1 ? 's' : ''}` }}
          </Pill>
          <div class="shop-footer__cart-total">
            <span class="shop-footer__cart-total--primary">
              {{ `Total today: $${cartItemsTotalAmount}` }}
            </span>
            <span class="shop-footer__cart-total--secondary">before tax</span>
          </div>
        </div>
        <div class="shop-footer__cta--mobile-only">
          <button
            class="btn btn--tertiary shop-footer__cta-clear-cart"
            v-if="!isCartEmpty"
            @click="clearCart"
          >
            Clear cart
          </button>
        </div>
      </div>
      <div class="shop-footer__cta-block">
        <div class="shop-footer__cta--desktop-only">
          <button
            class="btn btn--tertiary shop-footer__cta-clear-cart"
            v-if="!isCartEmpty"
            @click="clearCart"
          >
            Clear cart
          </button>
        </div>
        <button
          class="btn btn--primary btn--responsive btn--full-mobile shop-footer__cta-checkout"
          :disabled="isCartEmpty"
          @click="handleClickContinue"
        >
          Continue to checkout
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Pill from '@/components/shared/Pill.vue'
import { updateCart, mixpanelEvent } from '@/helpers/mixins'

export default {
  name: 'ShopFooter',
  components: {
    Pill,
  },
  mixins: [updateCart, mixpanelEvent],
  computed: {
    ...mapState({
      availableLiveVirtualTrainings: state => state.products.availableLiveVirtualTrainings,
      userProfile: state => state.auth.userProfile,
    }),
    ...mapGetters({
      totalStr: 'priceDetails/getTotalStr',
      shoppingCart: 'shoppingCart/getShoppingCart',
    }),
    isCartEmpty() {
      return this.shoppingCart.length === 0
    },
    cartItemsCount() {
      return this.shoppingCart.length
    },
    cartItemsTotalAmount() {
      return this.totalStr
    },
    liveVirtualTrainingsInCart() {
      const codes = this.availableLiveVirtualTrainings.map(p => p.merchant_id)
      return this.shoppingCart.filter(i => codes.includes(i.merchant_id))
    },
  },
  methods: {
    handleClickContinue() {
      try {
        this.gaBeginCheckout()
        this.$router.push({
          name: this.userProfile.email ? 'payment' : 'account',
        })
      } catch (error) {
        console.warn('Continue to checkout Error:', error)
        this.$router.push({
          name: this.userProfile.email ? 'payment' : 'account',
        })
      }
    },
  },
}
</script>

<style lang="scss">
.shop-footer {
  width: 100%;
  position: sticky;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  background: var(--mid-gray-gradient);
  padding: 20px;
  color: var(--white);
  font-family: var(--font-regular);
  z-index: 10;
  @include mobile {
    padding: 20px 50px;
  }
  &__content {
    width: 100%;
    max-width: 1120px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: column;
    @include mobile {
      flex-flow: row;
    }
  }
  &__cart {
    &--empty {
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      margin-bottom: 15px;
      @include mobile {
        font-size: 20px;
        line-height: 26px;
        margin-bottom: 0;
      }
      &-secondary {
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        @include mobile {
          font-size: 18px;
          line-height: 24px;
        }
        font-style: italic;
        color: var(--deactivated-feature);
      }
    }
    &-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      @include mobile {
        width: unset;
        display: block;
      }
    }
    &-total-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &-pill {
      margin-right: 10px;
    }
    &-total {
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      display: flex;
      flex-flow: column;
      @include mobile {
        font-size: 20px;
        line-height: 26px;
        display: block;
      }
      &--secondary {
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        font-style: italic;
        color: var(--deactivated-feature);
        @include mobile {
          font-size: 18px;
          line-height: 24px;
          padding-left: 5px;
        }
      }
    }
  }
  &__cta {
    &-block {
      width: 100%;
      @include mobile {
        width: unset;
        display: flex;
      }
    }
    &-clear-cart {
      margin-right: 10px;
      display: none;
      @include mobile {
        display: block;
      }
    }
    &-checkout {
      text-decoration: none;
    }
    &--mobile-only {
      display: block;
      @include mobile {
        display: none;
      }
      .btn {
        margin-right: 0;
      }
    }
    &--desktop-only {
      display: none;
      @include mobile {
        display: block;
      }
    }
  }
}
</style>
